import createIcon from '../../createIcon';

/**
 * @component @name AssuredWorkload
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiA5LjVINFYxNi41SDZWOS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDkuNUgxMFYxNi41SDEyVjkuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSA1LjVMMTEgMC41TDEgNS41VjcuNUgyMVY1LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMSAxOC41VjIwLjVIMTMuNEMxMy4xOSAxOS44NiAxMy4wOCAxOS4xOSAxMy4wNCAxOC41SDFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTggMTEuNzZWOS41SDE2VjEyLjc2TDE4IDExLjc2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5IDEzLjVMMTUgMTUuNVYxOC4wNUMxNSAyMC41NyAxNi43MSAyMi45MyAxOSAyMy41QzIxLjI5IDIyLjkzIDIzIDIwLjU3IDIzIDE4LjA1VjE1LjVMMTkgMTMuNVpNMTguMjggMjAuNUwxNi4yNSAxOC40N0wxNy4zMSAxNy40MUwxOC4yOCAxOC4zOEwyMC42OSAxNkwyMS43NSAxNy4wNkwxOC4yOCAyMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AssuredWorkload = createIcon('AssuredWorkload', [
  ['path', { d: 'M6 9.5H4V16.5H6V9.5Z', key: '1oulhz' }],
  ['path', { d: 'M12 9.5H10V16.5H12V9.5Z', key: 'tshfse' }],
  ['path', { d: 'M21 5.5L11 0.5L1 5.5V7.5H21V5.5Z', key: '1wqxgf' }],
  ['path', { d: 'M1 18.5V20.5H13.4C13.19 19.86 13.08 19.19 13.04 18.5H1Z', key: '1o3utr' }],
  ['path', { d: 'M18 11.76V9.5H16V12.76L18 11.76Z', key: '1bbbx5' }],
  [
    'path',
    {
      d: 'M19 13.5L15 15.5V18.05C15 20.57 16.71 22.93 19 23.5C21.29 22.93 23 20.57 23 18.05V15.5L19 13.5ZM18.28 20.5L16.25 18.47L17.31 17.41L18.28 18.38L20.69 16L21.75 17.06L18.28 20.5Z',
      key: '18l9hs',
    },
  ],
]);

export default AssuredWorkload;
